/**
 * Как непрочитанное выглядит в кружке.
 *
 * Лежит в общем слое, а не при ряде серверов, потому что кружков два: один на
 * значке сервера, другой на строке канала. Пока эти двенадцать строк жили в
 * ряду серверов, список каналов тянул их оттуда — то есть виджет лез в
 * соседний виджет.
 */

/**
 * Число для кружка.
 *
 * Трёхзначное не влезает и не нужно: разница между «сто сообщений» и «двести»
 * ни на что не влияет, а строка от неё разъезжается.
 */
export function count(value: number): string {
  return value > 99 ? "99+" : String(value);
}

/**
 * Что стоит в кружке: сколько нового и звали ли лично.
 *
 * Число всегда про непрочитанное целиком, а собачка впереди — про то, что
 * среди него есть адресованное вам. Показывать вместо числа количество
 * упоминаний значило бы прятать остальное: «1» вместо «@14» читается как
 * «одно сообщение», хотя ждут четырнадцать.
 */
export function tally(unread: number, mentions: number): string {
  return (mentions > 0 ? "@" : "") + count(unread);
}
